import { type ComponentProps } from 'react';
import { ListBoxItem } from '@launchpad-ui/components';

export function PickerItem(props: ComponentProps<typeof ListBoxItem>) {
  return <ListBoxItem {...props} />;
}
